export const validateMessage = ({ iframe, origin, source }) => {
  const isAllowedOrigin = origin === window.location.origin;
  const isAllowedSource = source === iframe;
  const isIFrameDefined = iframe !== undefined;

  return isAllowedOrigin && isAllowedSource && isIFrameDefined;
};
